import React, { useState } from "react";
import {
    Paper,
    Button,
    TextField,
    Typography,
    IconButton,
    Checkbox,
    FormControl,
    Select,
    MenuItem,
    Tooltip,
} from "@material-ui/core";

import {
    Close,
    CropSquare,
    Remove,
    Description,
    LocalOffer,
    AttachMoney,
    Layers,
    ExitToApp,
    Print,
    Save,
    Add,
    FirstPage,
    LastPage,
    NavigateBefore,
    NavigateNext,
    NoteAdd,
    KeyboardArrowDown,
    Store,
} from "@material-ui/icons";

import "./addNotes.css";
import { insh, sto } from "../../../Context/InshData";
import { Autocomplete } from "@material-ui/lab";
import PumpsAppbar from "../Pumps/PumpsAppbar";
import { useStylesBA, useStylesCAB } from "../../../St/comps/UseStyle";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import axios from "axios";
import { uri } from "../../../help/Api";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

// ==========================================
// Header
// ==========================================

const NotesHeader = () => {

    return (

        <div className="an-header">

            <div className="an-window-controls">

                <IconButton>
                    <Close />
                </IconButton>

                <IconButton>
                    <CropSquare />
                </IconButton>

                <IconButton>
                    <Remove />
                </IconButton>

            </div>

            <div className="an-header-title">

                <Typography>
                    إضافة الملاحظات
                </Typography>

                <Description />

            </div>

        </div>

    );

};

// ==========================================
// Input Component
// ==========================================

const NotesInput = ({
    label,
    icon,
    value,
    onChange,
    type = "text",
    focused = false,
}) => {

    return (

        <div className="an-field">

            <div className="an-field-label">

                {icon}

                <Typography>
                    {label}
                </Typography>

            </div>

            <TextField
                fullWidth
                variant="outlined"
                size="small"
                type={type}
                value={value}
                onChange={onChange}
                className={`an-text-input ${focused ? "an-input-focused" : ""
                    }`}
            />

        </div>

    );

};

// ==========================================
// Select Component
// ==========================================

const NotesSelect = ({
    label,
    icon,
    value,
    onChange,
    options,
    checked,
    onChecked,
    AutoOptions,
}) => {

    return (

        <div className="an-field">

            <div className="an-field-label">

                {icon}

                <Typography>
                    {label}
                </Typography>

            </div>

            <FormControl
                variant="outlined"
                size="small"
                className="an-select"
            >

                <Select
                    value={value}
                    onChange={onChange}
                    displayEmpty
                    IconComponent={KeyboardArrowDown}
                >

                    <MenuItem value="">
                        <em>اختر {label}</em>
                    </MenuItem>

                    {options.map((item, index) => (

                        <MenuItem
                            key={index}
                            value={item}
                        >
                            {item.name}
                        </MenuItem>

                    ))}

                </Select>

            </FormControl>

            <div className="an-checkbox">

                <Checkbox
                    checked={checked}
                    onChange={onChecked}
                    color="primary"
                />

                <span>تن</span>

            </div>

        </div>

    );

};

const GroupSelect2 = ({
    label,
    icon,
    options,
    checked,
    onChecked,
    AutoOptions,
    onChangeAutoGroupsMain,
    form
}) => {

    return (

        <div className="an-field">

            <div className="an-field-label">

                {icon}

                <Typography>
                    {label}
                </Typography>

            </div>

            <FormControl
                variant="outlined"
                size="small"
                className="an-select"
            >

                <Autocomplete
                    value={form?.group}
                    labelPlacement=""
                    onChange={(event, newValue) => {
                        onChangeAutoGroupsMain("group", newValue);
                    }}
                    id="groups1"
                    size="small"
                    options={options}
                    getOptionLabel={(option) =>
                        typeof option === "string" ? option : option.name
                    }
                    // style={{  }}
                    disableClearable
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={""}
                            variant="outlined"
                            size="small"
                        // InputLabelProps={{ className: claslbl.clrBlackLbl }}
                        />
                    )}
                />
            </FormControl>

            <div className="an-checkbox">

                <Checkbox
                    checked={checked}
                    onChange={onChecked}
                    color="primary"
                />

                <span>تن</span>

            </div>

        </div>

    );

};


// ==========================================
// Form
// ==========================================

const NotesForm = ({
    form,
    setForm,
    items,
    groups,
    AutoOptions
}) => {

    const update = (key, value) => {
        setForm(prev => ({
            ...prev,
            [key]: value,
        }));
    };

    return (

        <Paper className="an-form">

            <div className="an-form-fields">

                <NotesInput
                    label="الملاحظة"
                    icon={<Description />}
                    value={form.name}
                    onChange={e => update("name", e.target.value)}
                />

                <NotesInput
                    label="الملاحظة En"
                    icon={<LocalOffer />}
                    value={form.nameEn}
                    onChange={e => update("nameEn", e.target.value)}
                />

                <NotesInput
                    label="السعر"
                    icon={<AttachMoney />}
                    type="number"
                    value={form.price}
                    onChange={e => update("price", e.target.value)}
                    focused
                />

                <NotesSelect
                    label="الصنف"
                    icon={<Store />}
                    value={form.item}
                    onChange={e => update("item", e.target.value)}
                    options={items}
                    checked={form.itemEnabled}
                    onChecked={e => update("itemEnabled", e.target.checked)}
                    AutoOptions={AutoOptions}
                />

                <NotesSelect
                    label="المجموعة"
                    icon={<Layers />}
                    value={form.group}
                    onChange={e => update("group", e.target.value)}
                    options={groups}
                    checked={form.groupEnabled}
                    onChecked={e => update("groupEnabled", e.target.checked)}
                />

            </div>

        </Paper>

    );

};


// ==========================================
// Data Table
// ==========================================

const NotesTable = ({
    data,
    selected,
    onSelect,
}) => {

    return (

        <Paper className="an-table-container">

            <div className="an-table-scroll">

                <table className="an-table">

                    <thead>

                        <tr>

                            <th>الملاحظة</th>

                            <th>الملاحظة انجليزي</th>

                            <th>السعر</th>

                            {/* <th>اسم الصنف</th> */}

                        </tr>

                    </thead>

                    <tbody>

                        {data.map((row, index) => (

                            <tr
                                key={row.id}
                                onClick={() => onSelect(row)}
                                className={
                                    selected === index
                                        ? "an-selected-row"
                                        : ""
                                }
                            >
                                <td>{row.name}</td>

                                <td>{row.nameEn}</td>

                                <td>{row.price}</td>

                                {/* <td>{row.itemName}</td> */}

                            </tr>

                        ))}

                        {data.length === 0 && (

                            <tr>

                                <td
                                    colSpan="4"
                                    className="an-empty"
                                >
                                    لا توجد ملاحظات
                                </td>

                            </tr>

                        )}

                    </tbody>

                </table>

            </div>

        </Paper>

    );

};

// ==========================================
// Footer Button
// ==========================================

const FooterButton = ({
    icon,
    title,
    onClick,
    type = "normal",
}) => {

    return (

        <Button
            className={`an-footer-button an-${type}`}
            onClick={onClick}
        >

            {icon}

            <span>{title}</span>

        </Button>

    );

};

// ==========================================
// Main Component
// ==========================================

export default function AddNotes(props) {
    const { AutoOptions,isDialog ,setOpenNotes} = props;
    const newData = {
        note: "",
        expiry: "",
        price: "",
        item: "",
        group: "",
        itemEnabled: false,
        groupEnabled: false,
        id: 0,
        name: "",
        nameEn: "",
        group_id: -1,
        curr_id: -1,
        branch: sto.branchi,
        db_name: sto.db_name,
    };

    const [form, setForm] = useState(newData);
    const { t } = useTranslation(["forms"]);
    const his = useHistory();

    const [prevent, setPrevent] = React.useState(true);
    const clasBA = useStylesBA();
    const clasCAB = useStylesCAB();
    const [uiElement, setUiElement] = useState({});

    const backHome = () => {
        if(isDialog){
            setOpenNotes(false);
        }else{
            his.push({ pathname: "/" });
        }
    };
    const back = () => {
        if(isDialog){
            setOpenNotes(false);
        }else{
            his.goBack();
        }
    };
    const timer = React.useRef();
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });
    const [setting, setSetting] = useState({
        screen: "",
        tb: { parms: {}, autos: {} },
    });
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const buttonClassnameNew = clsx({ [clasCAB.buttonSuccessCAB]: success?.new });
    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });

    const [data, setData] = useState(AutoOptions?.bill_notes ?? []);
    const [selected, setSelected] = useState(0);
    // New
    const ButtonLoading = (prop) => {
        setLoading({ ...loading, [prop]: true });
    };
    const ButtonSuccess = (prop, timr) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            handNew();
            setPrevent(true);
        }, 2000);
    };
    // Save

    const addToBS = () => {
        if (!form.name.trim()) return;

        const _Data = {
            ...form,
            curr_id: form?.item?.id,
            group_id: form?.group?.id,
            price: Number(form.price || 0),
        };

        ButtonLoading("save");
        prevent
            ? axios
                .post(uri + "bill_notes", _Data)
                .then((res) => {
                    setData([...data, res?.data].sort((a, b) => a.id - b.id));
                    ButtonSuccess("save", 1000);
                    toast.success(t("save-success"));
                })
                .catch((res) => {
                    ButtonSuccess("save", 1000);
                    toast.error(t("save-failed"));
                })
            :
            axios
                .put(uri + "bill_notes", _Data)
                .then((res) => {
                    let newData = data.filter(a => String(a.id) !== String(form.id));
                    setData([...newData, res?.data].sort((a, b) => a.id - b.id));
                    ButtonSuccess("update", 1000);
                    toast.success(t("update-success"));
                })
                .catch((res) => {
                    ButtonSuccess("update", 1000);
                    toast.error(t("update-process-error"));
                });
    };

    const deleteToI = async () => {
        if (selected === null) return;
        ButtonLoading("delete");

        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls = `bill_notes?id=${form.id}`
        } else {
            Urls = `bill_notes?id=${form.id}&&db_name=${sto?.db_name}`
        }
        await axios.delete(uri + Urls).then(res => {
            setData(prev => prev.filter(a => String(a.id) !== String(form.id)).sort((a, b) => a.id - b.id));
            ButtonSuccess("delete", false);
            toast.success("The Account Deleted");
        }).catch(err => {
            ButtonSuccess("delete", false);
            toast.error("not delete ")
        });
    };

    const newToI = (timr) => {
        ButtonSuccess("new", timr);
        setUiElement({...uiElement,DeleIcon:false});
    };
    const onSelect = (row) => {
        setPrevent(false);
        setForm(row);
    };

    const handNew = () => {
        setUiElement({...uiElement,DeleIcon:true});
        setForm(newData);
        setPrevent(true);
    };

    return (
        <div className="an-screen" dir="rtl">
            <NotesHeader />
            <div className="an-content">
                <NotesForm
                    form={form}
                    setForm={setForm}
                    items={AutoOptions.items ?? []}
                    groups={AutoOptions?.groups ?? []}
                />
                <NotesTable
                    data={data}
                    selected={selected}
                    onSelect={onSelect}
                />
                <PumpsAppbar {...{
                    rptParams: form,
                    buttonClassnameNew,
                    buttonClassnameSave,
                    buttonClassnameDelete,
                    clasCAB,
                    newToI,
                    setting,
                    deleteToI,
                    addToBS,
                    loading,
                    clasBA,
                    backHome,
                    back,
                    uiElement,
                    prevent
                }}
                />
            </div>

        </div>

    );

}